// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.root[data-v-23b55fff] {\n\theight: 100vh;\n}\n.md-up[data-v-23b55fff] {\n\tmax-height: 95vh;\n}\n.scroll-view[data-v-23b55fff]{\n\twidth: 100%;\n\theight: 100%;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
